import './page-loader.scss'

const setStyles = () => {
    document.body.style.overflow = 'visible'
    const event = new CustomEvent('pageLoadEnd')
    document.dispatchEvent(event)
}

const initPageLoder = () => {
    document.addEventListener('pageLoad', setStyles)
}

initPageLoder()